import Vue from 'vue'
import { validationMixin } from 'vuelidate'
import { required, email } from 'vuelidate/lib/validators'

export default Vue.extend({
  mixins: [validationMixin],
  validations: {
    name: { required },
    email: { required, email },
  },
  props: {
    defaultName: {
      type: String,
      default: '',
    },
    defaultEmail: {
      type: String,
      default: '',
    },
    locked: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      name: '',
      email: '',
      nameDirty: false,
      emailDirty: false,
    }
  },
  computed: {
    emailError() {
      if (!this.$v.email.$error) {
        return ''
      }

      if (!this.$v.email.email) {
        return this.tr('errors.type.general.email_invalid')
      }

      return this.tr('errors.type.required')
    },
  },
  watch: {
    defaultName: {
      handler(value) {
        if (!this.nameDirty) {
          this.name = value
        }
      },
      immediate: true,
    },
    defaultEmail: {
      handler(value) {
        if (!this.emailDirty) {
          this.email = value
        }
      },
      immediate: true,
    },
  },
  methods: {
    onSubmit() {
      if (this.locked) {
        return
      }

      this.$v.$touch()

      if (!this.$v.$invalid) {
        this.$emit('change', {
          name: this.name,
          email: this.email,
        })
      }
    },
  },
})
